const DEFAULT_PAGE_NUMBER = 1;
const DEFAULT_PAGE_SIZE = 10;

const STATUS_COLORS = {
  uploading: "#E8F4FD",
  uploaded: "#E8F4FD",
  analysing: "#EBF4EC",
  analysed: "#EBF4EC",
  failed: "#FAEAEA",
};

const PENDING_DOCUMENT_STATUS = ["uploading", "uploaded"];

export {
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  STATUS_COLORS,
  PENDING_DOCUMENT_STATUS,
};
